import React from 'react';

import SettingsOutlinedIcon from '@mui/icons-material/SettingsOutlined';
import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined';

const ChooseRolePopupActions = ({config, onViewPermissions, onClose}) => (
    <div className="flex flex-col gap-1 pt-1" style={{borderTop: '1px solid var(--panels-normal-color)'}}>
        <div
            className="flex items-center gap-1.5 px-1 py-1.5 text-sm text-link-normal cursor-pointer hover:underline"
            onClick={() => { onClose(); if (config.onManageRoles) config.onManageRoles(); }}
        >
            <SettingsOutlinedIcon style={{fontSize: 16}} />
            Manage Roles
        </div>
        <div
            className="flex items-center gap-1.5 px-1 py-1.5 text-sm text-link-normal cursor-pointer hover:underline"
            onClick={onViewPermissions}
        >
            <InfoOutlinedIcon style={{fontSize: 16}} />
            View Combined Permissions
        </div>
    </div>
);

export default ChooseRolePopupActions;
